import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useUser } from 'context/UserContext'
import useSnowplow from 'hooks/useSnowplow'
import { ContinueButton } from 'components/ContinueButton'
import { RoutePaths } from 'route-paths'

interface Props {
  nextRoute: string
}

export const FeedbackGoalChoice: React.FC<Props> = ({ nextRoute }) => {
  const { t } = useTranslation('translation', {
    useSuspense: false,
  })

  const { snowplowTrack } = useSnowplow()
  const { user } = useUser()
  const navigate = useNavigate()

  const onContinue = () => {
    snowplowTrack({
      eventName: 'navigation_click',
      property: 'feedback_goalchoice',
    })
    navigate(nextRoute)
  }

  useEffect(() => {
    if (!user.firstGoal) {
      navigate(RoutePaths.Goals, { replace: true })
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!user.firstGoal) {
    return null
  }

  return (
    <>
      <div className="container mx-auto px-4 text-center">
        <div className="flex justify-center">
          <img
            src={'/images/feedback_goalchoice.png'}
            className="my-5 h-auto w-[400px] text-center"
            alt="Feedback Goal Choice"
          />
        </div>
        <h1 className="mt-10 text-center font-title text-2xl font-bold text-black">
          {t('feedback_goal_choice.headline')}{' '}
          <span className="text-ar-green">
            {t(`feedback_goal_choice.${user.firstGoal?.id}.title`)}
          </span>
        </h1>

        <p
          className="mt-4 font-body text-sm text-ar-dark-gray xl:text-center"
          dangerouslySetInnerHTML={{
            __html: t(`feedback_goal_choice.${user.firstGoal.id}.body`),
          }}
        />
      </div>
      <ContinueButton onClick={onContinue} />
    </>
  )
}
